<div class="bg-illustration vh-100"></div>
<div class="login-container">
  <img
    src="../../../assets/img/schulio-black.png"
    alt="Schulio Public"
    class="img-responsive img-raised rounded w-100 p-2"
  />
  <div class="z-i-5">
    <div class="">
      <div>
        <div>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>

  <div class="bottom-flex">
    <p class="back" *ngIf="IsLogin">
      <a routerLink="/public">Zurück zur Übersicht</a>
    </p>
    <p class="back" *ngIf="IsPasswordReset">
      <a routerLink="/login/login">Zurück zum Login</a>
    </p>
    <p class="reset" *ngIf="IsLogin">
      <a routerLink="/login/password">Passwort vergessen</a>
    </p>
  </div>
  <p class="hiptmairit-reference" *ngIf="!IsLogin && !IsPasswordReset">
    <a href="https://www.hiptmairit.at/schulio" target="_blank"
      >Weitere Informationen zu Schulio</a
    >
  </p>
</div>
